export default "__VITE_ASSET__deLOCD5Y__"